import { useCreateLoanInterest } from 'hooks/loans/mutations';
import { useGetListings } from 'hooks/useGetListings';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import useAlert from 'utils/alert';
import { HUD_1 } from 'utils/constants';
import { InterestKindEnum } from 'v2-types/order';

import { CreateInterestForm } from '../../types';
import { filterKindList } from './utils/filterKindList';

type Params = {
  onClose: () => void;
  orderType: string;
  loanId?: string;
};
export const useCreateInterestModal = ({ onClose, orderType, loanId }: Params) => {
  const { id: orderId } = useParams<{ id: string }>();
  const showAlert = useAlert();
  const createInterestInitialValues: CreateInterestForm = {
    kind: orderType === HUD_1 ? InterestKindEnum.fixed : InterestKindEnum.only,
  };
  const createInterestForm = useForm<CreateInterestForm>({
    defaultValues: createInterestInitialValues,
    mode: 'onChange',
  });

  const { data: kindListingResponse, isLoading: isLoadingListing } = useGetListings({
    code: 'allowed_interest_blocks',
  });
  const kindListing = filterKindList({
    kindList: kindListingResponse?.getListing.entries ?? [],
    orderType,
  });

  const { mutate: createInterest, isLoading: isCreateInterestLoading } = useCreateLoanInterest({
    queryConfig: {
      onSuccess: () => {
        showAlert('Interest successfully created', 'success');
        onClose();
      },
    },
  });

  const onConfirm = createInterestForm.handleSubmit((data) => {
    if (!loanId) return;

    createInterest({
      orderId,
      loanId,
      ...data,
    });
  });

  return {
    createInterestForm,
    onConfirm,
    isCreateInterestLoading,
    isLoadingListing,
    kindListing,
  };
};
